import React from 'react'
import { connect } from 'react-redux'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import PropTypes from 'prop-types'
import DeleteSite from 'view/page/site-management/component/delete-site'
import EditSite from 'view/page/site-management/component/edit-site'
import NewPermittedGroup from 'view/page/site-management/component/new-permitted-group'
import OrderCategories from 'view/page/site-management/component/order-categories'
import formatInputs from 'helper/format-input-fields'
import { isPlAdmin } from 'helper/is-pl-admin'
import styles from './styles'

// Hiding the item is cosmetic: the server only lets a PL admin delete.
const Action = ({ site, user }) =>
  (<span>
    <Dropdown
      overlay={
        <Menu >
          <Menu.Item>
            <EditSite site={formatInputs(site)} />
          </Menu.Item>
          <Menu.Item>
            <OrderCategories site={formatInputs(site)} />
          </Menu.Item>
          <Menu.Item>
            <NewPermittedGroup siteUuid={site.uuid} />
          </Menu.Item>
          {isPlAdmin(user) &&
            <Menu.Item>
              <DeleteSite site={site} />
            </Menu.Item>}
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  site: PropTypes.object,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

export default connect(mapStateToProps)(Action)
